export const checkinEditDrawer = {
  header: {
    title: "Edytuj dane check-in",
    age: "Wiek:",
    docNotRequiredMinor: "Dokument niewymagany (osoba niepełnoletnia)",
    docOptionalMinorES: "Dokument opcjonalny (osoba niepełnoletnia w Hiszpanii)",
    docOptionalMinorCO: "Dokument opcjonalny (poniżej 7 lat w Kolumbii)",
  },
  sections: {
    basicData: "Dane podstawowe",
    stayDates: "Daty pobytu",
    italyDoc: "Dokument i kraj urodzenia",
    doc: "Dokument i narodowość",
  },
  fields: {
    firstName: "Imię",
    lastName: "Nazwisko",
    email: "E-mail",
    phone: "Telefon",
    birthDate: "Data urodzenia",
    sex: "Płeć",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Rodzaj dokumentu",
    docNumber: "Numer dokumentu",
    supportNumber: "Numer nośnika",
    nationality: "Narodowość",
  },
  placeholders: {
    select: "Wybierz",
    selectNationality: "Wybierz narodowość",
    searchCountry: "Szukaj kraju...",
    selectCountry: "wybierz kraj",
    docNumberExample: "np. AB1234567",
    docNumberGeneric: "DNI / NIE / Paszport",
    required: "Wymagane",
    optional: "Opcjonalne",
  },
  sex: {
    male: "Mężczyzna",
    female: "Kobieta",
    preferNotToSay: "Wolę nie podawać",
    other: "Inna",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "Kraj urodzenia",
    birthCountryHint: "używany także jako obywatelstwo",
    issuePlaceLabel: "Miejsce wydania dokumentu",
    issuePlaceHint: "kraj, w którym wydano dokument",
    alloggiatiCode: "Kod Alloggiati:",
    iso3Label: "ISO3:",
    minorNote:
      "Osoba niepełnoletnia: rodzaj, numer i miejsce wydania dokumentu są wysyłane do Alloggiati Web jako puste (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Dokument opcjonalny zgodnie z regułą wieku i kraju. Nadal można go uzupełnić.",
  },
  docTypes: {
    it: {
      IDENT: "Dokument tożsamości (IDENT)",
      IDELE: "Elektroniczny dokument tożsamości (IDELE)",
      PASOR: "Paszport zwykły (PASOR)",
      PASSE: "Paszport służbowy (PASSE)",
      PASDI: "Paszport dyplomatyczny (PASDI)",
      PATEN: "Prawo jazdy (PATEN)",
      PATNA: "Patent żeglarski (PATNA)",
      CIDIP: "Dyplomatyczny dokument tożsamości (CIDIP)",
      RIFUG: "Dokument podróży uchodźcy (RIFUG)",
    },
    co: {
      CC: "Dowód osobisty",
      CE: "Dowód osobisty cudzoziemca",
      P: "Paszport",
      PPT: "Zezwolenie na ochronę tymczasową",
      PEP: "Specjalne zezwolenie na pobyt",
      DE: "Dokument zagraniczny",
      CD: "Legitymacja dyplomatyczna",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Paszport",
      OTRO: "Inny",
    },
    generic: {
      ID: "Dokument tożsamości",
      P: "Paszport",
      OTRO: "Inny",
    },
  },
  footer: {
    cancel: "Anuluj",
    save: "Zapisz",
    saving: "Zapisywanie...",
  },
  errors: {
    nameRequired: "Imię i nazwisko są wymagane.",
    emailInvalid: "Nieprawidłowy adres e-mail.",
    phoneRequired: "Telefon jest wymagany.",
    birthDateRequired: "Data urodzenia jest wymagana.",
    sexRequired: "Płeć jest wymagana.",
    stayDatesRequired: "Daty pobytu są wymagane.",
    checkoutBeforeCheckin: "Data check-out nie może być wcześniejsza niż data check-in.",
    birthCountryRequired: "Kraj urodzenia jest wymagany.",
    docTypeRequired: "Rodzaj dokumentu jest wymagany.",
    docNumberRequired: "Numer dokumentu jest wymagany.",
    issuePlaceRequired: "Miejsce wydania dokumentu jest wymagane.",
    nationalityRequired: "Narodowość jest wymagana.",
    supportNumberRequired:
      "Numer nośnika jest wymagany dla narodowości hiszpańskiej (osoba pełnoletnia).",
    saveFailed: "Nie udało się zapisać.",
    saveError: "Błąd podczas zapisywania zmian.",
  },
  toast: {
    saved: "Check-in został zaktualizowany",
  },
};
